export default "__VITE_ASSET__UZf3E2Po__"